export default "__VITE_ASSET__BnwineyQ__"